import { render, staticRenderFns } from "./PendingPopup.vue?vue&type=template&id=71f33f05&scoped=true"
import script from "./PendingPopup.vue?vue&type=script&lang=js"
export * from "./PendingPopup.vue?vue&type=script&lang=js"
import style0 from "./PendingPopup.vue?vue&type=style&index=0&id=71f33f05&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f33f05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f33f05')) {
      api.createRecord('71f33f05', component.options)
    } else {
      api.reload('71f33f05', component.options)
    }
    module.hot.accept("./PendingPopup.vue?vue&type=template&id=71f33f05&scoped=true", function () {
      api.rerender('71f33f05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PendingPopup.vue"
export default component.exports